// extracted by css-extract-rspack-plugin
var _1 = "a_SXKim8SVYxjYjc";
export { _1 as "bright" }
